<template>
  <div class="empty-cart-container" @click="$emit('addNewCart')">
    <button class="add-new-cart-btn">
      <span class="add-cart-text">Add New Cart</span>
      <svg
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 0.297607C12.8837 0.297607 13.6 1.01395 13.6 1.89761V9.89761H21.6C22.4837 9.89761 23.2001 10.614 23.2001 11.4976C23.2001 12.3813 22.4837 13.0976 21.6 13.0976H13.6V21.0976C13.6 21.9813 12.8837 22.6976 12 22.6976C11.1164 22.6976 10.4 21.9813 10.4 21.0976V13.0976H2.40005C1.51639 13.0976 0.800049 12.3813 0.800049 11.4976C0.800049 10.614 1.51639 9.89761 2.40005 9.89761H10.4V1.89761C10.4 1.01395 11.1164 0.297607 12 0.297607Z"
          fill="#003D6A"
        />
      </svg>
    </button>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
defineEmits(["addNewCart"]);
</script>

<style scoped>
@import "@/assets/css/colors.css";

.empty-cart-container {
  border: 2px dashed var(--border-dashed);
  border-radius: 16px;
  padding: 30px 0;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.add-new-cart-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 48px;
  border-radius: 16px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.add-new-cart-btn:hover {
  transform: translateY(-2px);
}

.add-cart-text {
  font-family: "Inter", sans-serif;
  font-size: var(--fs-xl);
  font-weight: 700;
  line-height: 32px;
  color: var(--primary-blue);
}
</style>
